/* ============================================================
   GalaxyGadgetz — Premium Effects
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  // ── Detecteer productpagina via data-template op <main> (Horizon theme) ──
  const mainEl = document.getElementById('MainContent');
  const onProductPage = !!(mainEl && (mainEl.dataset.template || '').includes('product'));

  // ── 1. Scroll reveal (fade-in + slide-up) — niet op productpagina ──

  if (!onProductPage) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('gg-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    document.querySelectorAll(
      '.card, .product-card-wrapper, .gg-feature-card, .gg-pt-badge, ' +
      '.gg-pt-review, .gg-cp-item, .gg-cp-faq-item'
    ).forEach((el, i) => {
      el.classList.add('gg-reveal');
      el.style.transitionDelay = `${(i % 6) * 80}ms`;
      revealObserver.observe(el);
    });

    document.querySelectorAll(
      '.gg-cp-section-title, .gg-cp-faq-title, .gg-pt-reviews-title'
    ).forEach(el => {
      el.classList.add('gg-reveal');
      revealObserver.observe(el);
    });
  }


  // ── 2. Hero parallax (muisbeweging) ───────────────────────
  const heroes = document.querySelectorAll('.gg-cp-hero, .hero .media-wrapper');
  heroes.forEach(hero => {
    const parent = hero.closest('.gg-cp-hero') || hero.closest('.hero') || hero;
    parent.addEventListener('mousemove', e => {
      const { left, top, width, height } = parent.getBoundingClientRect();
      const x = ((e.clientX - left) / width - 0.5) * 18;
      const y = ((e.clientY - top) / height - 0.5) * 10;
      if (parent.classList.contains('gg-cp-hero')) {
        parent.style.backgroundPosition = `calc(50% + ${x}px) calc(50% + ${y}px)`;
      } else {
        const img = parent.querySelector('img, video');
        if (img) img.style.transform = `scale(1.04) translate(${x * 0.4}px, ${y * 0.4}px)`;
      }
    });
    parent.addEventListener('mouseleave', () => {
      if (parent.classList.contains('gg-cp-hero')) {
        parent.style.backgroundPosition = 'center center';
      } else {
        const img = parent.querySelector('img, video');
        if (img) img.style.transform = '';
      }
    });
  });


  // ── 3. Magnetisch knop effect (alleen buiten productpagina) ──
  if (!onProductPage) {
    document.querySelectorAll(
      '.button:not([disabled]):not(.product-form__submit):not([name="add"]), .gg-cp-submit'
    ).forEach(btn => {
      btn.addEventListener('mousemove', e => {
        const rect = btn.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width - 0.5) * 14;
        const y = ((e.clientY - rect.top) / rect.height - 0.5) * 8;
        btn.style.transform = `translate(${x}px, ${y}px) translateY(-2px)`;
      });
      btn.addEventListener('mouseleave', () => {
        btn.style.transform = '';
      });
    });
  }


  // ── 4. Cursor glow (alleen desktop) ───────────────────────
  if (window.matchMedia('(pointer: fine)').matches) {
    const glow = document.createElement('div');
    glow.className = 'gg-cursor-glow';
    document.body.appendChild(glow);

    let mx = window.innerWidth / 2;
    let my = window.innerHeight / 2;
    let cx = mx, cy = my;
    let rAFId = null;
    let lastMove = 0;

    document.addEventListener('mousemove', e => {
      mx = e.clientX;
      my = e.clientY;
      lastMove = Date.now();
      if (!rAFId) rAFId = requestAnimationFrame(animate);
    });

    function animate() {
      cx += (mx - cx) * 0.08;
      cy += (my - cy) * 0.08;
      glow.style.transform = `translate(${cx}px, ${cy}px) translate(-50%, -50%)`;
      if (Date.now() - lastMove < 150) {
        rAFId = requestAnimationFrame(animate);
      } else {
        rAFId = null;
      }
    }
  }


  // ── 5. Teller animatie (data-count attribuut) ─────────────
  const counterObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      const target = parseInt(el.dataset.count, 10);
      const suffix = el.dataset.suffix || '';
      const prefix = el.dataset.prefix || '';
      let current = 0;
      const duration = 1200;
      const startTime = performance.now();

      const tick = (now) => {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        current = Math.round(eased * target);
        el.textContent = prefix + current + suffix;
        if (progress < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
      counterObserver.unobserve(el);
    });
  }, { threshold: 0.5 });

  document.querySelectorAll('[data-count]').forEach(el => counterObserver.observe(el));


  // ── 6. Ripple effect op knoppen bij klik (niet op add-to-cart) ──
  document.querySelectorAll(
    '.button:not(.product-form__submit):not([name="add"]), .gg-cp-submit'
  ).forEach(btn => {
    btn.addEventListener('click', e => {
      const rect = btn.getBoundingClientRect();
      const ripple = document.createElement('span');
      const size = Math.max(rect.width, rect.height) * 2;
      ripple.className = 'gg-ripple';
      ripple.style.cssText = `
        width: ${size}px;
        height: ${size}px;
        left: ${e.clientX - rect.left - size / 2}px;
        top: ${e.clientY - rect.top - size / 2}px;
      `;
      btn.appendChild(ripple);
      ripple.addEventListener('animationend', () => ripple.remove());
    });
  });

});
